import {Component, inject} from '@angular/core';
import {ApplicationCommonComponent} from "../../../common/application.common.component";
import {StagesComponent} from "../../../../../../common/stages/stages.component";
import {stages} from "../../contact-data-update.routes";
import {SpinnerComponent} from "../../../../../../common/spinner/spinner.component";
import {RouterLink} from "@angular/router";
import {CurrentResidentialAddressForm} from "./forms/current-residential-address.form";
import {ReactiveFormsModule} from "@angular/forms";
import {CommonModule} from "@angular/common";
import {ValidationErrorsComponent} from "../../../../../../common/validation-errors/validation-errors.component";
import {NgxMaskDirective} from "ngx-mask";
import {ApplicationAppEntityApplicationRead} from "../../../../../../openapi";

@Component({
  selector: 'app-current-residential-address-section',
  standalone: true,
  imports: [
    StagesComponent,
    SpinnerComponent,
    RouterLink,
    ReactiveFormsModule,
    CommonModule,
    ValidationErrorsComponent,
    NgxMaskDirective
  ],
  providers: [CurrentResidentialAddressForm],
  templateUrl: './current-residential-address-section.component.html'
})
export class CurrentResidentialAddressSectionComponent extends ApplicationCommonComponent {

  public stages = stages;

  public form: CurrentResidentialAddressForm = inject(CurrentResidentialAddressForm);

  public override onFetchApplicationData = (app: ApplicationAppEntityApplicationRead | null) => {
    if (app) {
      this.form.patchFormValues({
        ...app
      });
    }
  };

  public submitAndGoNext(): void {
    if (this.form.valid) {
      this.updateApplication('adres-do-doreczen', this.form.toWriteModel())
    } else {
      this.form.markAllAsTouched();
    }
  }
}
